import type { Dispatch, SetStateAction } from 'react';
import type { BuilderDeviceTab, BuilderPassTab } from './templateBuilderTabs';

export const MAIN_TABS = {
  PASS_TEMPLATE: 0,
  ISSUANCE_FORM: 1,
} as const;

export const scrollToSection = (sectionId: string) => {
  const section = document.getElementById(sectionId);
  if (section) {
    const position = section.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: position - 25,
      behavior: 'smooth',
    });
  }
};

export interface NavigationConfig {
  mainTabIndex: number;
  tab?: BuilderDeviceTab;
  passTab?: BuilderPassTab;
  sectionId: string;
  expandLocationIndex?: number;
}

interface NavigationSetters {
  setSelectedMainTabIndex: (index: number) => void;
  setSelectedTab: Dispatch<SetStateAction<BuilderDeviceTab>>;
  setSelectedPassTab: Dispatch<SetStateAction<BuilderPassTab>>;
  setPendingExpandLocationIndex?: Dispatch<SetStateAction<number | null>>;
}

export const navigateToSection = (
  {
    setSelectedMainTabIndex,
    setSelectedTab,
    setSelectedPassTab,
    setPendingExpandLocationIndex,
  }: NavigationSetters,
  config: NavigationConfig
) => {
  setSelectedMainTabIndex(config.mainTabIndex);
  if (config.tab) setSelectedTab(config.tab);
  if (config.passTab) setSelectedPassTab(config.passTab);
  if (
    typeof config.expandLocationIndex === 'number' &&
    setPendingExpandLocationIndex
  ) {
    setPendingExpandLocationIndex(config.expandLocationIndex);
  }
  setTimeout(() => {
    scrollToSection(config.sectionId);
  }, 200);
};
